export enum KeyFormCisFertigation {
  Id = 'id',
  Name = 'name',
  Fertiliser = 'fertiliser',
  Agitator = 'agitator',
  Flushing = 'flushing',
  FlowSensor = 'flowSensor',
  PumpStart = 'pumpStart',
  WaterLevel = 'waterLevel'
}

export interface OptionItem {
  interfaceId: number
  index: number
  address: number
  name: string
  hiddenAdress: number
  decoderTypeId: number
}
